import { render, staticRenderFns } from "./CodePage.vue?vue&type=template&id=becc3868"
import script from "./CodePage.vue?vue&type=script&lang=js"
export * from "./CodePage.vue?vue&type=script&lang=js"
import style0 from "./CodePage.vue?vue&type=style&index=0&id=becc3868&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports